import { CobaltActionBar } from '@cae/cobalt-react/components/action-bar';
import { CobaltButton } from '@cae/cobalt-react/components/button';
import { MediaQuery } from '@cae/cobalt-react/enums';
import { useMediaQuery } from '@cae/cobalt-react/hooks';
import { useHasPermission } from '@contexts/permissions-provider';
import { UsersContent } from '@features/users/components/content/UsersContent';
import { UsersHeader } from '@features/users/components/header/UsersHeader';
import { UsersDataProvider } from '@features/users/contexts/data/UsersDataProvider';
import { UsersFilterProvider } from '@features/users/contexts/filter/UsersFilterProvider';
import { useUserNavigation } from '@features/users/hooks/use-user-navigation/useUserNavigation';
import * as React from 'react';
import { Outlet } from 'react-router-dom';

import styles from './UsersPage.module.css';

const UsersPage = React.memo((): React.ReactElement => {
  const isMobileAndTablet = useMediaQuery(MediaQuery.MobileAndTablet);
  const { navigateToCreateUser } = useUserNavigation();
  const canAdd = useHasPermission('Users_Add_Org');

  return (
    <UsersFilterProvider>
      <UsersDataProvider>
        <div data-testid="users-page" className={styles.usersPage}>
          <UsersHeader />
          <UsersContent />

          {isMobileAndTablet && canAdd && (
            <CobaltActionBar
              mobile
              variant="floating"
              primaryButton={
                <CobaltButton variant="primary" onClick={navigateToCreateUser}>
                  Create new user
                </CobaltButton>
              }
            ></CobaltActionBar>
          )}

          <Outlet />
        </div>
      </UsersDataProvider>
    </UsersFilterProvider>
  );
});

UsersPage.displayName = 'UsersPage';

export { UsersPage };
